import apiClient from "../apiClient";
import { HOLIDAYS_ENDPOINTS } from "../endpoints/holidays";
import {
  buildHolidayFilterPayload,
  compactHolidayListPayload,
} from "@/utils/holidayListing";

export const fetchFeaturedJourney = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.featuredJourney);
    return response.data;
  } catch (error) {
    console.error("Error fetching featured journey:", error);
    throw error;
  }
};

export const fetchUnlockParadise = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.unlockParadise);
    return response.data;
  } catch (error) {
    console.error("Error fetching featured journey:", error);
    throw error;
  }
};

export const fetchHolidayHome = async (params) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.home, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday home:", error);
    throw error;
  }
};

export const fetchHolidaysList = async (payload = {}) => {
  try {
    const response = await apiClient.post(
      HOLIDAYS_ENDPOINTS.list,
      compactHolidayListPayload(payload)
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching holidays list:", error);
    throw error;
  }
};

export const fetchPackageDetailsBySlug = async (params = {}) => {
  try {
    const { country, packageSlug, slug, HolidaySlug, ...rest } = params;
    const holidaySlug = HolidaySlug || packageSlug || slug || "";
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.detailsBySlug, {
      params: {
        ...rest,
        HolidaySlug: holidaySlug,
      },
      // ...(country ? { headers: { country } } : {}),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching package details by slug:", error);
    throw error;
  }
};

export const fetchHolidayPackages = async (params) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.packages, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday packages:", error);
    throw error;
  }
};

export const fetchHolidayPackageById = async (id) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.packageById, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday package:", error);
    throw error;
  }
};

export const fetchHolidayFilters = async (query = {}) => {
  try {
    const response = await apiClient.post(
      HOLIDAYS_ENDPOINTS.holidayFilters,
      buildHolidayFilterPayload(query)
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday filters:", error);
    throw error;
  }
};

export const fetchHolidayDestinations = async (params) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.destinations, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday destinations:", error);
    throw error;
  }
};

export const searchHolidays = async (payload = {}) => {
  try {
    const response = await apiClient.post(HOLIDAYS_ENDPOINTS.search, payload);
    return response.data;
  } catch (error) {
    console.error("Error searching holidays:", error);
    throw error;
  }
};

export const searchHoliday = async (prefix = "") => {
  try {
    const query = String(prefix || "").trim();
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.searchHoliday, {
      params: query ? { prefix: query } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error searching holiday destinations:", error);
    throw error;
  }
};

export const fetchHolidaysBreaks = async (isVisaFree) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.holidaysBreaks, {
      params: { isVisaFree },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching holidays breaks:", error);
    throw error;
  }
};

export const submitDownloadItineraryForm = async (payload) => {
  try {
    const response = await apiClient.post(
      HOLIDAYS_ENDPOINTS.downloadItinerary,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting download itinerary form:", error);
    throw error;
  }
};

export const downloadHolidayItineraryPdf = async (params) => {
  try {
    const response = await apiClient.get(
      HOLIDAYS_ENDPOINTS.downloadHolidayItineraryPdf,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading holiday itinerary:", error);
    throw error;
  }
};

export const fetchSimilarHolidays = async (packageId) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.similarHolidays, {
      params: { PackageId: packageId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching similar holidays:", error);
    throw error;
  }
};

export const fetchHolidayHomePageHeading = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.homePageHeading);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday home page heading:", error);
    throw error;
  }
};

export const fetchHolidayHomePageAdvertisement = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.homePageAdvertisement);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday home page advertisement:", error);
    throw error;
  }
};

export const fetchHolidayListPageHeading = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.listPageHeading);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday list page heading:", error);
    throw error;
  }
};

export const fetchRandomHolidayDestinations = async (noOfDestinationEach = 10) => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.randomDestination, {
      params: { noOfDestinationEach },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching random holiday destinations:", error);
    throw error;
  }
};

export const fetchHolidayTravelTypes = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.travelType);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday travel types:", error);
    throw error;
  }
};

export const fetchHolidayInterestTypes = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.interestType);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday interest types:", error);
    throw error;
  }
};

export const fetchHolidayExperienceTypes = async () => {
  try {
    const response = await apiClient.get(HOLIDAYS_ENDPOINTS.experienceType);
    return response.data;
  } catch (error) {
    console.error("Error fetching holiday experience types:", error);
    throw error;
  }
};

export const fetchSmartHolidaysList = async (payload = {}) => {
  try {
    const response = await apiClient.post(
      HOLIDAYS_ENDPOINTS.smartHolidaysList,
      { ...payload, travelType: 0, experienceType: 0, interestType: 0 }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching smart holidays list:", error);
    throw error;
  }
};

export const submitSmartSearchEnquiry = async (payload = {}) => {
  try {
    const response = await apiClient.post(
      HOLIDAYS_ENDPOINTS.submitSmartSearchEnquiry,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting smart search enquiry:", error);
    throw error;
  }
};
